import * as actionTypes from './actionTypes';
import axios from "axios";
import api from "../../shared/api";

export const getAgentsInProductStart=()=>{
    return {
        type:actionTypes.GET_AGENTS_IN_PRODUCT_START,
    }
}

export const getAgentsInProductSuccess=(allAgents)=>{
    return {
        type:actionTypes.GET_AGENTS_IN_PRODUCT_SUCCESS,
        agents:allAgents,
    }
}

export const getAgentsInProductFail=(err)=>{
    return {
        type:actionTypes.GET_AGENTS_IN_PRODUCT_FAIL,
        error:err
    }
}

export const getAgentsInProduct=(productId,token)=>{
    return async dispatch=>{
        dispatch(getAgentsInProductStart());
        let url =`${api}/products/${productId}/agents`;
        const options = {
            url: url,
            method: 'GET',
            headers: {
                'Authorization': 'Bearer '+token
             },
            data:{}
          };
          await axios(options)
          .then(response => {
          dispatch(getAgentsInProductSuccess(response.data));
        })
        .catch(err => {
          dispatch(getAgentsInProductFail(`Get agents in product Failed - ${err}`));
        });
    }
}


//create

export const createTransactionStart=()=>{
    return {
        type:actionTypes.CREATE_TRANSACTION_START
    }
}

export const createTransactionSuccess=(text)=>{
    return {
        type:actionTypes.CREATE_TRANSACTION_SUCCESS,
        message:text
    }
}

export const createTransactionFail=(text)=>{
    return {
        type:actionTypes.CREATE_TRANSACTION_FAIL,
        error:text
    }
}

export const createTransaction=(pid,tArr,token)=>{
    return async dispatch=>{
        dispatch(createTransactionStart());
        let url =`${api}/transactions/winlose`;
        const options = {
            url: url,
            method: 'POST',
            headers: {
                'Authorization': 'Bearer '+token
             },
            data:{
                productId:pid,
                winLoseInfos:tArr

            }
          };
          await axios(options)
          .then(response => {
          dispatch(createTransactionSuccess('create transaction success'));
        })
        .catch(err => {
          dispatch(createTransactionFail(`Create Transaction Failed - ${err}`));
        });
    }
}

//clear agents in product
export const clearAgentsInProduct=()=>{
    return dispatch=>{
        dispatch({type:actionTypes.CLEAR_AGENTS_IN_PRODUCT});
    }
}